import React from "react";
import useFetchableData from "../../../../hooks/useFetchableData";
import InvestorsDraftService from "../../services/InvestorService";
import AdminService from "../../services/AdminService";

function useInvestorExtraData(session) {
    const aums = useFetchableData(() => {
        return AdminService.aums(session)
    }, 'aumRanges');
    const countries = useFetchableData(() => {
        return AdminService.countries(session)
    }, 'countries');
    const riaCountries = useFetchableData(() => {
        return AdminService.riaCountries(session)
    }, 'countries');
    const countriesByRegion = useFetchableData(() => {
        return AdminService.countriesByRegion(session)
    }, 'countries');
    const states = useFetchableData(() => {
        return AdminService.states(session)
    }, 'us_states');
    const regions = useFetchableData(() => {
        return AdminService.regions(session)
    }, 'regions');
    const cities = useFetchableData(() => {
        return AdminService.riaCities(session)
    }, 'cities');
    const geographicFocuses = useFetchableData(() => {
        return AdminService.geographicFocuses(session)
    }, 'geographicFocuses');
    const strategyFocuses = useFetchableData(() => {
        return AdminService.strategyFocuses(session)
    }, 'strategies');
    const assetClassFocuses = useFetchableData(() => {
        return AdminService.assetClassFocuses(session)
    }, 'assetClassFocuses');
    const industryWealthOrigins = useFetchableData(() => {
        return AdminService.industryWealthOrigins(session)
    }, 'industryWealthOrigins');
    const investmentStyles = useFetchableData(() => {
        return AdminService.investmentStyles(session)
    }, 'investmentStyles');
    const investmentStages = useFetchableData(() => {
        return AdminService.investmentStages(session)
    }, 'investmentStages');
    const contactResponsibilities = useFetchableData(() => {
        return AdminService.contactResponsibilities(session)
    }, 'contactResponsibilities');
    const investorTypes = useFetchableData(() => {
        return AdminService.investorTypes(session)
    }, 'investor_types');
    const relationships = useFetchableData(() => {
        return AdminService.relationships(session)
    }, 'relationships');
    const realEstateInvestments = useFetchableData(() => {
        return AdminService.realEstateInvestments(session)
    }, 'realEstateInvestment');
    const extraData = useFetchableData(() => {
        return InvestorsDraftService.extraData(session)
    });
    const itemStages = useFetchableData(() => {
        return AdminService.itemStages(session)
    }, 'item_stages');
    const foundationStages = useFetchableData(() => {
        return AdminService.foundationStages(session)
    });
    const investmentStrategies = useFetchableData(() => {
        return AdminService.investmentStrategies(session)
    }, 'investmentStrategies');
    return {
        aums,
        countries,
        riaCountries,
        countriesByRegion,
        states,
        regions,
        cities,
        geographicFocuses,
        strategyFocuses,
        assetClassFocuses,
        industryWealthOrigins,
        extraData,
        investmentStyles,
        investmentStages,
        contactResponsibilities,
        investorTypes,
        relationships,
        itemStages,
        foundationStages,
        investmentStrategies
    }
}

export default useInvestorExtraData;